module.exports = __webpack_public_path__ + "img/official_ticket.6211d172.png";